import { PoliticasComponent } from './politicas/politicas.component';
import { Routes, RouterModule } from '@angular/router';

import { MetaGuard } from '@ngx-meta/core';

import { UniversidadeComponent } from './universidade.component';
import { SobreComponent } from './sobre/sobre.component';
import { IngressoComponent } from './ingresso/ingresso.component';
import { EgressosComponent } from './egressos/egressos.component';
import { CorpoDirigenteComponent } from './corpo-dirigente/corpo-dirigente.component';
import { GrupoCeumaComponent } from './grupo-ceuma/grupo-ceuma.component';
import { CpaComponent } from './cpa/cpa.component';
import { EadComponent } from './ead/ead.component';
import { NucleoComponent } from './nucleo/nucleo.component';
import { NucleoDetalhesComponent } from './nucleo/nucleo-detalhes/nucleo-detalhes.component';

import { NOTICIAS_ROUTER } from './noticias/noticias.router';
import { BOLSAS_FINANCIAMENTO_ROUTER } from './bolsas-financiamento/bolsas-financiamento.router';
import { environment } from '../../environments/environment';

const UNIVERSIDADE_ROUTER: Routes = [
  {
    path: '',
    component: UniversidadeComponent,
    canActivate: [MetaGuard],
    data: {
      meta: {
        title: environment.title,
        description: `Saiba mais Sobre ${environment.loginContexto=='CEUMA'?'a Universidade':'o Centro Universitário'} e nossos campi`,
      },
    },
    children: [
      { path: '', redirectTo: 'sobre', pathMatch: 'full' },
      { path: 'sobre', component: SobreComponent },
      { path: 'ingresso', component: IngressoComponent },
      { path: 'egressos', component: EgressosComponent },
      { path: 'corpo-dirigente', component: CorpoDirigenteComponent },
      { path: 'grupo-ceuma', component: GrupoCeumaComponent },
      { path: 'cpa', component: CpaComponent },
      { path: 'ead', component: EadComponent },
      { path: 'nucleos', component: NucleoComponent },
      { path: 'nucleos/:slug', component: NucleoDetalhesComponent },
      ...BOLSAS_FINANCIAMENTO_ROUTER,
      ...NOTICIAS_ROUTER,
    ],
  },
];

export const UniversidadeRouter = RouterModule.forChild(UNIVERSIDADE_ROUTER);
